<template>
  <div class="skel-card">
    <div class="skel skel-media"></div>
    <div class="skel-body">
      <div class="skel skel-line w-70"></div>
      <div class="skel skel-line w-40"></div>
      <div class="skel skel-line w-90"></div>
      <div class="skel-chips">
        <div class="skel skel-chip"></div>
        <div class="skel skel-chip"></div>
      </div>
      <div class="skel skel-btn"></div>
    </div>
  </div>
</template>

<script setup>
</script>

<style scoped>
.skel-card {
  background: #fff;
  border: 1px solid rgba(5, 22, 41,.08);
  border-radius: 20px;
  overflow: hidden;
}
.skel { background: #e9edf5; border-radius: 8px; position: relative; overflow: hidden; }
.skel::after {
  content: '';
  position: absolute; inset: 0;
  transform: translateX(-100%);
  background: linear-gradient(90deg, transparent, rgba(255,255,255,.6), transparent);
  animation: skel-shimmer 1.3s infinite;
}
@keyframes skel-shimmer { 100% { transform: translateX(100%); } }
.skel-media { aspect-ratio: 16 / 9; border-radius: 0; }
.skel-body { padding: 1rem 1.1rem 1.1rem; }
.skel-line { height: 12px; margin-bottom: .6rem; }
.w-70 { width: 70%; } .w-40 { width: 40%; } .w-90 { width: 90%; }
.skel-chips { display: flex; gap: .4rem; margin: .3rem 0 .9rem; }
.skel-chip { width: 72px; height: 22px; border-radius: 8px; }
.skel-btn { height: 40px; border-radius: 12px; }
</style>
